const { APIChannelService } = require("../../config/axios-channel-service");

const api = new APIChannelService();

const Auth = {
  currentRoleUser: () => {
    return api.get(`/api/v1/sys-user`);
  },
  updateRole: (roleSelect) => {
    return api.put(`/api/v1/sys-user/update-role?roleId=${roleSelect}`);
  },
  sendOTPUsername: (username) => {
    return api.post(`/public-api/v1/sys-user/send-otp/${username}`);
  },
};
export { Auth };
